/**
 * フロントページ メインスライド
 */
import $ from 'jquery'

export default function () {

  var $pickupSlick = $('.js-front-pickup').slick({
    dots: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 4000,
    draggable: false,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          speed: 800,
          fade: true,
          draggable: true,
          variableWidth: false,
          centerMode: false,
          autoplay: false
        }
      }
    ]
  });
}

/**
 * 実行
 */
//setPickupSlide()
